import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadDashboardSections,
  deleteDashboardSection,
} from '../../../../../state/modules/dashboardSections/actions';
import DashboardSectionsList from '../components/DashboardSectionsList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.dashboardSections.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['dashboardSections', x]),
                schema.dashboardSection,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              partnership_name: x?.partnership?.name ?? '',
              partnership_plan: x?.partnership?.plan?.name ?? '',
              ...x,
            };
          })
      : [],
    isLoading: state.dashboardSections.get('isLoading'),
    total: state.dashboardSections.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadDashboardSections(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteDashboardSection(id, cb));
    },
  };
};

const DashboardSectionsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardSectionsList);

export default DashboardSectionsListContainer;
